module.exports = __webpack_public_path__ + "img/ref2.5f0df049.png";